import { useState } from 'react';

let sharedData = null;
const listeners = [];

const notify = () => {
  listeners.forEach((setState) => setState(sharedData));
};

export function useAppSharedData() {
  const [data, setLocalData] = useState(sharedData);

  const setData = (newData) => {
    sharedData = newData;
    notify();
  };

  // subscribe on first render
  if (!listeners.includes(setLocalData)) {
    listeners.push(setLocalData);
  }

  return {
    data,
    setData,
  };
}
